import React from "react";

export function UnsafeHtml({ children, tag: Tag = "span", ...restProps }) {
  const unsafeContent = {
    __html: children,
  };
  // @ts-ignore
  return <Tag dangerouslySetInnerHTML={unsafeContent} {...restProps} />;
}
